import { dbQueueWithCurDateRef } from "../../api/queue";
import { db } from "../../FirebaseConfig";
import { ref, get, update } from "firebase/database";
import { format } from 'date-fns';


 /**
  * Calculate the average wait time for served guests and estimate wait time for waiting guests in the queue.
  * @param {*} guestToken - The guest token representing the current guest's data, which includes information like `queueId`, `status`, `position`, and other relevant fields.
 *  @returns {Promise<void>} A promise that resolves once the Firebase database update is complete. Errors are caught and logged if any issues occur.                             
  */

async function CalculateAverageWaitTime(guestToken){
   try{
      const snapshot= await get(dbQueueWithCurDateRef(guestToken.queueId, 'guests'))
      if (snapshot.exists()) {
         // Access the actual data
         const guestTokens = snapshot.val(); 
         const guestsTokensArr = Object.values(guestTokens); 
         const servedGuests = guestsTokensArr.filter(t => t.status === 'served')
         const totalWaitTime = servedGuests.reduce((sum, servedToken) => sum + servedToken.waitTime, 0);
         const averageWaitTime = totalWaitTime / servedGuests.length;
         const totalStartingPosition  = servedGuests.reduce((sum, servedToken) => sum + servedToken.startedPosition
         , 0);
         const averageStartingPosition = totalStartingPosition / servedGuests.length;
         const averageWaitTimePerPosition = averageWaitTime/averageStartingPosition;
         const date = format(Date.now(), 'yyyy-MM-dd');
         const queueRef = ref(db, `queues/${guestToken.queueId}/daily_stats/${date}`);
         await update(queueRef, {averageWaitTimePerPosition})
       } else {
         console.error("No guest tokens data available.");
       }
   }catch(e){
      console.error(e.message)
   }
}

export default CalculateAverageWaitTime;

